import axios from "../utils/axios";

export const adminContactApi = (data) =>
  axios.post(
    "/api/admin/contact/create",
    data
  );

  export const getContactApi = () =>
  axios.get(
    "/api/admin/contact/all"
  );